import React, { useState, useEffect, useCallback } from "react";
import { Button, Stepper, useMantineTheme } from "@mantine/core";
import {
  Clock,
  Code,
  Database,
  FileDescription,
  Filter,
} from "tabler-icons-react";
import { useMediaQuery } from "@mantine/hooks";
import {
  Query,
  QueryInfo,
  ReportInfo,
  ReportProps,
  ReportComponentName,
  ReportSetupState,
  initialColumns,
    ReportUISetupState,
  QueryFlag,
    ReportUI,
    Filter as GlobalFilter,
    SelectedFilterItem,
    ReportInfoDTO,
} from "../../types/types";
import { StepperContent } from "../kpi/setup/stepper/content/StepperContent";
import { ReportDetailsFormPage } from "./ReportCreationFormPages/ReportBasicDetailsPage-I/ReportDetailsFormPage";
import { ReportTransformation } from "./ReportCreationFormPages/ReportTransformationPage-III/ReportTransformation";
import { EntityReportFormPage } from "./ReportCreationFormPages/ReportQueryFormPage-II/EntityReportFormPage";
import { JrxmlFormPage } from "./ReportCreationFormPages/JRXMLFormPage-V/JrxmlFormPage";
import { StepperContentVertical } from "../kpi/setup/stepper/content/StepperContentVertical";
import { ReportBasicDetailsValidator } from "./ReportCreationFormPages/ReportBasicDetailsPage-I/ReportBasicDetailsValidator";
import { ConfirmationPopUp } from "../popup/confirmationPopUp";
import { FinalPreviewPage } from "./ReportCreationFormPages/FinalPreviewPage-VI/FinalPreviewPage";
import {
  commonPost,
  commonPut,
  getReportInfoById,
} from "../../services/reportService";
import { useAuth } from "../../providers/AuthProvider";
import { showNotification } from "@mantine/notifications";
import { X } from "tabler-icons-react";
import { QueryEditorValidator } from "./ReportCreationFormPages/ReportQueryFormPage-II/QueryEditorValidator";
import { FinalPreviewValidator } from "./ReportCreationFormPages/FinalPreviewPage-VI/FinalPreviewValidator";
import { JrxmlFormPageValidation } from "./ReportCreationFormPages/JRXMLFormPage-V/validation/JrxmlFormPageValidation";
import { ViewReportPage } from "./ReportCreationFormPages/ViewReportGenratePage-VIII/ViewReportPage";
import { QueryEditorReport } from "./ReportCreationFormPages/ReportQueryFormPage-II/QueryEditorReport";
import { ReportGlobalFilterValidator } from "./ReportCreationFormPages/ReportGlobalFilterDetailsPage-VII/ReportGlobalFilterValidator";
import { ReportGlobalFilterFormPage } from "./ReportCreationFormPages/ReportGlobalFilterDetailsPage-VII/ReportGlobalFilterPage"
import { ChannelkartNetworkPost, ChannelkartNetworkPut } from "../../services/networkService";
import { current } from "@reduxjs/toolkit";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { popupType } from "../../types/types";
import { GenericPopUp } from "../popup/genericPopUp";


export function popNotification(
  title: string,
  message: string,
  color: string,
  icon?: any
): void {
  showNotification({
    title,
    message,
    color,
    icon,
    autoClose: 5000,
  });
}

export function Report() {
  

  let authContext = localStorage.getItem("authContext") && JSON.parse(localStorage.getItem("authContext") as string);
  let theme = useMantineTheme();
  const matches = useMediaQuery("(max-width: 990px)");

  const initialColumns: initialColumns = {
    Query_Columns: {
      id: "Query_Columns",
      list: [],
    },
    Report_Columns: {
      id: "Report_Columns",
      list: [],
    },
  };

  const setReportInfo = (reportInfo: ReportInfo) => {
    setState({ ...state, reportInfo });
  };

  const [openSubmitConfirmationModal, setOpenSubmitConfirmationModal] =
    useState<boolean>(false);
  const [openApproveConfirmationModal, setOpenApproveConfirmationModal] =
    useState<boolean>(false);
  const [state, setState] = useState<ReportSetupState>({
    loading: true,
    validationErrors: [],
    reportInfo: {} as ReportInfo,
  });

    const [reportUIState, setReportUIState] = useState<ReportUISetupState>({
        loading: true,
        validationErrors: [],
        reportUI: {} as ReportUI,
    });
  const [showDraggableList, setShowDraggableList] = useState<boolean>(true);
  const [valueReportType, setValueReportType] = useState<string>("simple");
  const [showInput, setShowInput] = useState<boolean>(false);
  const [query, setQuery] = useState<Query>({ name: "", query: "" });
  const [alertContent] = useState<string>("");
  const [columns, setColumns] = useState(initialColumns);
  const [columnsViewReport, setColumnsViewReport] = useState(initialColumns);
  const [showInputAddQueryColumn, setShowInputAddQueryColumn] =
    useState<boolean>(false);
    const [queryFlag, setQueryFlag] = useState<QueryFlag>(
      {
        Warning: [],
        "Not Allowed": []
    }
  );
  const [valueAddQueryColumn, setValueAddQueryColumn] = useState<string>("");
  const [active, setActive] = useState<number>(0);
  const [viewReportFlag, setViewReportFlag] = useState<boolean>(false);
  const [diffrentQueryForViewReportFlag, setDiffrentQueryForViewReportFlag] = useState<string>("yes");
  const [queryInfo, setQueryInfo] = useState<QueryInfo>({
    id: "",
    name: "",
    query: "",
    language: "",
    implementation: "",
    type: "",
    description: "",
    enabled: true,
    params: {},
    UIParams: [],
    owner: "",
    reviewer: "",
    reviewStatus: "PENDING",
  });
  const [openGenericModal, setOpenGenericModal] = useState(false);
  const [popupType, setPopupType] = useState<popupType>("Alert");
  const [genericMessage,setGenericMessage] = useState("");

    
  const [queryInfoViewReport, setQueryInfoViewReport] = useState<QueryInfo>({
    id: "",
    name: "",
    query: "",
    language: "",
    implementation: "",
    type: "",
    description: "",
    enabled: true,
    params: {},
    UIParams: [],
    owner: "",
    reviewer: "",
    reviewStatus: "PENDING",
  });

  const [extendedAttributesViewReports, setExtendedAttributesViewReports] = useState<any>({headers: {}})

    const filter: GlobalFilter = {
      allFilter: {
        list: [],
      }, globalFilter: {
        list: [],
      },
      selectedFilter: {
        list: [],
      },
      columns: []
    };

    const [reportUI, setReportUI] = useState<ReportUI>({
        globalFilter: filter
    } as ReportUI);

    const [showReport, setShowReport] = useState<boolean>(true);
    const [currentReportComponent, setCurrentReportComponent] = useState<ReportComponentName>('downloadReport');

  const reportProps: ReportProps = {
    ...state,
    setReportInfo,
    setReportState: setState,
    query,
    setQuery,
    queryInfo,
    setQueryInfo,
    alertContent,
    showDraggableList,
    setShowDraggableList,
    showInput,
    setShowInput,
    columns,
    setColumns,
    columnsViewReport,
    setColumnsViewReport,
    valueReportType,
    setValueReportType,
    showInputAddQueryColumn,
    setShowInputAddQueryColumn,
    valueAddQueryColumn,
    setValueAddQueryColumn,
      showHide: false,
      setReportUIState: setReportUIState,
      reportUI: reportUI,
    viewReportFlag,
    setViewReportFlag,
    diffrentQueryForViewReportFlag,
    setDiffrentQueryForViewReportFlag,
    queryInfoViewReport,
    setQueryInfoViewReport,
    setReportUI,
    showReport,
    setShowReport,
    currentReportComponent,
    setCurrentReportComponent,
    extendedAttributesViewReports,
    setExtendedAttributesViewReports,
    queryFlag,
    setQueryFlag
  };

    // function isLocationFilter(id: string) {
    //     return ["district", "branch", "zone", "state", "city", "region", "area", "territory", "regionCode", "stateCode", "areaCode", "territoryCode", "districtCode", "town"].includes(id);
    // }

    const processReportUI = (name: string, reportUI: ReportUI): any => {

        let globalFilter: SelectedFilterItem[] = [];
        let locationFilter: SelectedFilterItem[] = [];

        if (reportUI.globalFilter.selectedFilter.list.length > 0) {
            reportUI.globalFilter.selectedFilter.list.map((filter) => {
                // if (isLocationFilter(filter.id)) {
                //     locationFilter.push(filter)
                // } else {
                //     globalFilter.push(filter)
                // }
                globalFilter.push(filter);
            })
        }

        return {
            id: name,
            name: reportUI.label,
            type: reportUI.type,
            role: reportUI.role,
            filter: reportUI.filter,
            globalFilters: globalFilter,
            locationFilters: locationFilter
        };;
    }

  const stepperIconProps = {
    size: 40,
    strokeWidth: 2,
    color: theme.colorScheme === "dark" ? "white" : "black",
  };

  const prevStep = () => {
    if(active > 0 ){
      setActive((current) => (current > 0 ? current - 1 : current));
    }else{
      window.open("/dashboard/manageReport", "_self");
    }
  }

  const openPopup = (message:string, type:popupType)=>{
    setPopupType(type)
    setGenericMessage(message)
    setOpenGenericModal(true)
  }

  const nextStep = async () => {
    const validator = stepConfigurations[active].validator;
    if (validator) {
      const validationErrors = validator.validate(reportProps);
      if (validationErrors.length > 0) {
        setState({ ...state, validationErrors });
      } else {
        setState({ ...state, validationErrors: [] });
        // good to go to the next page
        nextPage();
      }
    } else {
      nextPage();
    }
  };

  const clickApproved = async () => {
    const validator = stepConfigurations[active + 1].validator;
    if (validator) {
      const validationErrors = validator.validate(reportProps);
      if (validationErrors.length > 0) {
        setState({ ...state, validationErrors });
      } else {
        openApproveConfirmation();
      }
    } else {
      openApproveConfirmation();
    }
  };

  function openSubmitConfirmation() {
    setOpenSubmitConfirmationModal(true);
  }

  function openApproveConfirmation() {
    setOpenApproveConfirmationModal(true);
  }

  async function submitReport() {
      let token = localStorage.getItem("token");
      let header = {};
      if(token){
        header = {internal_token: token};
      }
    ChannelkartNetworkPost("/v1/report",{
        reportInfo: reportProps.reportInfo,
          queryInfo: reportProps.queryInfo,
          reportUI: processReportUI(reportProps.reportInfo.name, reportProps.reportUI),
      },header)
      .then(function (data) {
        popNotification("Alert", "Report data saved succesfully", "green");
        window.open("/dashboard/manageReport", "_self");
      })
      .catch(function () {
        popNotification("Alert", "Something went wrong", "red", <X />);
      });
  }

  async function approveReport() {
    let token = localStorage.getItem("token");
      let header = {};
      if(token){
        header = {internal_token: token};
      }
    ChannelkartNetworkPut(
      "/v1/report/approve",
      {
        id: reportProps.reportInfo.id,
        status: "APPROVED",
        reviewer: localStorage.getItem("email"),
      },
      header
    )
      .then(function (data) {
        popNotification("Alert", "Report data approved succesfully", "green");
        window.open("/dashboard/manageReport", "_self");
      })
      .catch(function () {
        popNotification("Alert", "Something went wrong", "red", <X />);
      });
  }

  async function nextPage() {
    setActive((current) => {
      return current < 5 ? current + 1 : current;
    });
  }

  const stepConfigurations = [
    {
      icon: <FileDescription {...stepperIconProps} />,
      title: "Report Creation Details",
      description:
        "Hi there, Welcome to Report Creation wizard. This wizard helps you to create new REPORT. As the first step of this process, please provide a name and description for your REPORT. Remember we will use this name as a unique identifier for Report and a good description will be very useful for whoever referencing this Report",
      stepper: <ReportDetailsFormPage {...reportProps} />,
      stepperType: "HorizontalStep",
      validator: new ReportBasicDetailsValidator(),
      },
      {
          icon: <Filter {...stepperIconProps} />,
          title: "Global filter configuration",
          description:
              "Hi there, You can select the global filter for the report here",
          stepper: <ReportGlobalFilterFormPage {...reportProps} />,
          stepperType: "VerticalStep",
          validator: new ReportGlobalFilterValidator(),
      },
    {
      icon: <Filter {...stepperIconProps} />,
      title: "Query",
      description:
        "This will help you to select query for your Report and also edit or create new query for your report. You can check live result by entering parametrs",
      stepper: <QueryEditorReport {...reportProps} />,
      stepperType: "VerticalStep",
      validator: new QueryEditorValidator(),
    },
    {
      icon: <Filter {...stepperIconProps} />,
      title: "Entity",
      description:
        "This will help you to select query for your Report and also edit or create new query for your report. You can check live result by entering parametrs",
      stepper: <EntityReportFormPage {...reportProps} />,
      stepperType: "HorizontalStep",
    },
    {
      icon: <Database {...stepperIconProps} />,
      title: "Report Transformation",
      description:
        "This page help you to transform field headers for your report, also it would help to change color and theme of report.",
      stepper: <ReportTransformation {...reportProps} />,
      stepperType: "HorizontalStep",
      validator: new JrxmlFormPageValidation(),
    },
    {
      icon: <Code {...stepperIconProps} />,
      title: "JRXML",
      description:
        "This Page refer to header mapping. You can change header mapping by using simple mapping and can do complex stuff like color change,column width etc through JRML",
      stepper: <JrxmlFormPage {...reportProps} />,
      stepperType: "VerticalStep",
    },
    // {
    //   icon: <Code {...stepperIconProps} />,
    //   title: "View Report",
    //   description:
    //     "You can view your report here. Select if you want to change the query and mapping",
    //   stepper: <ViewReportPage {...reportProps} />,
    //   stepperType: "VerticalStep",
    //   // validator: new FinalPreviewValidator(),
    // },
    {
      icon: <Clock {...stepperIconProps} />,
      title: "Final Preview",
      description:
        "Great! You have successfully created the Report Configuration. Let's test it now:) ",
      stepper: <FinalPreviewPage {...reportProps} />,
      stepperType: "VerticalStep",
      validator: new FinalPreviewValidator(),
    }
  ];

  const queryParameters = new URLSearchParams(window.location.search);
  const id: string = queryParameters.get("id") as string;
  const view: string = queryParameters.get("view") as string;
  const review: string = queryParameters.get("review") as string;
  if (view || review) {
    reportProps.reportInfo.viewEditStatus = "VIEW";
  }
  if (review) {
    reportProps.reportInfo.reviewingStatus = "REVIEW";
  }

  

  const getReportInfo = useCallback ((id: any) => {
    if (id) {
      getReportInfoById(id).then((data) => {
        let reportInfoDto = data as any;
        setState((old) => {
          return {
            ...old,
            reportInfo: {
              ...old.reportInfo,
              ...reportInfoDto.reportInfo,
            },
          };
        });
        if (reportInfoDto.reportInfo.type === "QUERY") {
          setQuery({
            name: reportInfoDto.queryInfo.name,
            query: reportInfoDto.queryInfo.query,
          });
          setQueryInfo(reportInfoDto.queryInfo);
          }
          if (reportInfoDto.reportUI != null) {
              const filter: GlobalFilter = {
                allFilter: {
                  list: [],
                }, globalFilter: {
                  list: [],
                },
                selectedFilter: {
                  list: [...reportInfoDto.reportUI.globalFilters, ...reportInfoDto.reportUI.locationFilters],
                },
                columns: []
              };

              setReportUI({
                  globalFilter: filter,
                  role: reportInfoDto.reportUI.role,
                  label: reportInfoDto.reportUI.name,
                  type: reportInfoDto.reportUI.type,
                  filter: reportInfoDto.reportUI.filter
              } as ReportUI);
          } else {
              setShowReport(false)
          }
      });
    }
  },[]);

  useEffect(() => {
    getReportInfo(id);
  }, [getReportInfo,id]);

  const getSteps = () => {
    if (reportProps.reportInfo.type === "QUERY") {
      return stepConfigurations
        .filter((item) => item.title !== "ENTITY")
        .map((item) => {
          if (item.stepperType === "VerticalStep") {
            return (
              <Stepper.Step
                label={matches && item.title}
                key={item.description}
                icon={item.icon}
                disabled
              >
                <StepperContentVertical
                  title={!matches && item.title}
                  description={!matches ? item.description : ""}
                >
                  {item.stepper}
                </StepperContentVertical>
              </Stepper.Step>
            );
          } else if (item.stepperType === "HorizontalStep") {
            return (
              <Stepper.Step
                label={matches && item.title}
                key={item.description}
                icon={item.icon}
                disabled
              >
                <StepperContent
                  title={!matches && item.title}
                  description={!matches ? item.description : ""}
                >
                  {item.stepper}
                </StepperContent>
              </Stepper.Step>
            );
          }
          return null;  // Unreachable return but added to avoid warning
        });
    } else {
      return stepConfigurations
        .filter((item) => item.title !== "Query")
        .map((item) => {
          return (
            <Stepper.Step
              label={matches && item.title}
              key={item.description}
              icon={item.icon}
              disabled
            >
              <StepperContent
                title={!matches && item.title}
                description={!matches ? item.description : ""}
              >
                {item.stepper}
              </StepperContent>
            </Stepper.Step>
          );
        });
    }
  };
  return (
    <>
    <GenericPopUp message={genericMessage}
      type={popupType}
      openGenericModal={openGenericModal}
      setOpenGenericModal={setOpenGenericModal} />
      <div className={"kpi-setup-wrapper"}>
        <div className={"kpi-setup-stepper full-width-height"}>
          <Stepper
            className={"full-width-height"}
            size={"xl"}
            active={active}
            breakpoint={"md"}
            onStepClick={setActive}
            color={"teal"}
          >
            ¯{getSteps()}
          </Stepper>
        </div>
        <ConfirmationPopUp
          message="Do you want to save the report data?"
          openConfirmModal={openSubmitConfirmationModal}
          setOpenConfirmModal={setOpenSubmitConfirmationModal}
          successMethod={() => submitReport()}
        />
        <ConfirmationPopUp
          message="Do you want to approve the report?"
          openConfirmModal={openApproveConfirmationModal}
          setOpenConfirmModal={setOpenApproveConfirmationModal}
          successMethod={() => approveReport()}
        />
        {reportProps.reportInfo.reviewingStatus === "REVIEW" ? (
          <div className={"kpi-setup-buttons"}>
            <Button color="teal" variant="default" onClick={prevStep}>
              Back
            </Button>
            {active !== 4 ? (
              <Button color="teal" onClick={nextStep}>
                Next step
              </Button>
            ) : (
              <Button color="teal" onClick={clickApproved}>
                Approve
              </Button>
            )}
          </div>
        ) : (
          <div className={"kpi-setup-buttons"}>
            <Button color="teal" variant="default" onClick={prevStep}>
              Back
            </Button>
            {active !== 5 ? (
              <Button color="teal" onClick={nextStep}>
                Next step
              </Button>
            ) : (
              <Button
                color="teal"
                onClick={openSubmitConfirmation}
                disabled={
                  reportProps.reportInfo.viewEditStatus === "VIEW"
                    ? true
                    : false
                }
              >
                Submit
              </Button>
            )}
          </div>
        )}
      </div>
    </>
  );
}
